import Header from './Header.jsx';

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/index.jsx